import React, { useState, useEffect } from "react";
import ImageMapper from "react-img-mapper";
import { viewableUrlFile } from "../utils/utilityFunction";
import ReactAudioPlayer from "react-audio-player";
import { Box, IconButton } from "@mui/material";
import { AiOutlineZoomOut, AiOutlineZoomIn } from "react-icons/ai";

import darkClose from "../assets/icons/close-window-dark.png";
import hoverClose from "../assets/icons/close-window-hover.png";

const ZoomableImage = ({ image, onClose }) => {
  const zoomWidth = 100;
  const minWidth = 400;
  const [zoom, setZoom] = useState(640);
  const [audioFile, setAudioFile] = useState();

  const [mapAreas, setMapAreas] = useState({
    name: `zoom-buttons-${image.id}`,
    areas: [],
  });

  useEffect(() => {
    let tempAreas = [];

    image?.buttons?.forEach((element) => {
      let temp = {
        areaKeyName: element.id,
        id: element.id,
        shape: "circle",
        coords: [element.x, element.y, element.r],
        fillColor: "rgba(255, 255, 255, 0)",
      };

      tempAreas.push(temp);
      // let pauseBtn = {
      //   id: element.id + "-pause",
      //   shape: "circle",
      //   coords: [element.x + 65, element.y, element.r + 2],
      //   fillColor: "rgba(255, 255, 255, 0.5)",
      // };
      // tempAreas.push(pauseBtn);
    });
    setMapAreas((prev) => ({ ...prev, areas: tempAreas }));
  }, [image?.buttons]);

  const handleZoom = (type) => {
    setZoom((prev) => {
      if (prev <= minWidth && type === "out") return prev;
      return type === "in" ? prev + zoomWidth : prev - zoomWidth;
    });
  };

  const playAudio = React.useCallback(
    (evt) => {
      if (`${evt.id}`.includes("pause")) {
        console.log("pase button clicked");
        //get all button file for checking id with pause id and then pause the audio by ref
      }
      let tempBtn = image?.buttons.find((btn) => btn.id === evt.id);
      let tempAudio = viewableUrlFile(tempBtn?.audio_url);
      setAudioFile(`${process.env.REACT_APP_FILE_LOCATION}${tempAudio}`);
    },

    [image?.buttons, setAudioFile]
  );

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: "0px",
          right: "0px",
          width: "100%",
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        <Box
          sx={{
            backgroundImage: `url(${darkClose})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            cursor: "pointer",
            width: "40px",
            height: "40px",
            "&:hover": {
              backgroundImage: `url(${hoverClose})`,
            },
          }}
          onClick={onClose}
        />
        <IconButton onClick={() => handleZoom("in")}>
          <AiOutlineZoomIn />
        </IconButton>
        <IconButton onClick={() => handleZoom("out")}>
          <AiOutlineZoomOut />
        </IconButton>
        {audioFile && <ReactAudioPlayer src={audioFile} autoPlay controls />}
      </Box>

      <Box
        sx={{
          mt: "64px",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          background: (theme) => theme.palette.primary.light,
        }}
      >
        <ImageMapper
          src={`${process.env.REACT_APP_FILE_LOCATION}${viewableUrlFile(
            image?.image_url
          )}`}
          map={mapAreas}
          responsive
          parentWidth={zoom}
          onClick={playAudio}
        />
      </Box>
    </>
  );
};

export default ZoomableImage;
